module.exports = __webpack_public_path__ + "img/1601.2293de9d.png";